import { render, staticRenderFns } from "./DetailCanvas.vue?vue&type=template&id=640e92f2&scoped=true&"
import script from "./DetailCanvas.vue?vue&type=script&lang=js&"
export * from "./DetailCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DetailCanvas.vue?vue&type=style&index=0&id=640e92f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e92f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
